import React from 'react';
import { Link } from 'react-router-dom';
import './AuthButtons.css';

const AuthButtons = ({ onLinkClick, variant = 'full', loginPath = '/ride-login', signupPath = '/ride-signup', state }) => {
  if (variant === 'minimal') {
    // For FoodNavbar, which uses a button with navigate
    return (
      <button className="login-btn-minimal" onClick={onLinkClick}>
        Log In
      </button>
    );
  }

  if (variant === 'mobile') {
    return (
      <div className='navbar-mobile-auth-buttons'>
        <Link to={signupPath} state={state} className='navbar-mobile-signup-btn' onClick={onLinkClick}>
          Sign Up
        </Link>
        <Link to={loginPath} state={state} className='navbar-mobile-login-btn' onClick={onLinkClick}>
          Log In
        </Link>
      </div>
    );
  }
  // Default 'full' variant for the main navbar
  return (
    <div className='navbar-auth-buttons'>
      <Link to={loginPath} state={state} className='navbar-login-btn' onClick={onLinkClick}>
        Log In
      </Link>
      <Link to={signupPath} state={state} className='navbar-signup-btn' onClick={onLinkClick}>
        Sign Up
      </Link>
    </div>
  );
};

export default AuthButtons;